import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../componentsTopsa/buttons/TopButtons";
import {ButtonToolbar} from "react-bootstrap";
import TabUtilities from "../../../../utilities/TabUtilities";

export default class FirmyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtons = this.renderButtons.bind(this)
        this.formatNazwa = this.formatNazwa.bind(this)
        this.formatNip = this.formatNip.bind(this)
    }

    renderButtons(cell, row) {
        return (<div>
            <ButtonToolbar>
                <TopButtonPointEdit onClick={() => this.props.handleClickEdytuj(row)} titleContent={'Edytuj rekord'}/>
                <TopButtonPointRemove onClick={() => this.props.handleClickUsun(row)} titleContent={'Usuń rekord'}/>
            </ButtonToolbar>
        </div>)
    }

    formatAdres(cell, row) {
        let adres = row.miejscowosc

        if (row.ulica)
            adres += ' ' + row.ulica

        if (row.nrNieruchomosci)
            adres += ' ' + row.nrNieruchomosci

        if (row.nrLokalu)
            adres += '/' + row.nrLokalu

        return adres
    }

    formatNazwa(cell, row) {
        if (Boolean(row.idNabywcy)) {
            let nabywca = this.props.data.find(f => f.idFi === row.idNabywcy)
            if (nabywca) {
                return (<div>
                    <div>{cell}</div>
                    <div style={{color:'grey',fontSize:'12px',fontStyle:'italic'}}>Nabywca: {nabywca.nazwa}</div>
                </div>)
            } else {
                return (<div>
                    <div>{cell}</div>
                    <div style={{color:'grey',fontSize:'12px',fontStyle:'italic'}}>Instytucja jest odbiorcą!</div>
                </div>)
            }
        }
        else {
            return cell
        }
    }

    formatNip(cell, row) {
        if (Boolean(cell)) {
            return cell
        } else {
            if (Boolean(row.idNabywcy)) {
                let nabywca = this.props.data.find(f => f.idFi === row.idNabywcy)
                if (nabywca) {
                    return (<div>
                        <div style={{color:'grey',fontSize:'12px',fontStyle:'italic'}}>NIP nabywcy:</div>
                        <div style={{color:'grey'}}>{nabywca.nip}</div>
                    </div>)
                }
            }
        }
    }

    render() {

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
        };

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idFi' isKey hidden={false} thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazwa'
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                       dataFormat={this.formatNazwa}
                    >Nazwa</TableHeaderColumn>
                    <TableHeaderColumn dataField='nip'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                       dataFormat={this.formatNip}
                    >NIP</TableHeaderColumn>
                    <TableHeaderColumn dataField='regon'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                    >REGON</TableHeaderColumn>
                    <TableHeaderColumn dataField='miejscowosc'
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                                       dataFormat={this.formatAdres}
                    >Adres</TableHeaderColumn>
                    <TableHeaderColumn dataField='formaPrawna'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                    >Forma Prawna</TableHeaderColumn>
                    <TableHeaderColumn dataField='formaSzczegolowaNazwa'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj', disabled: true}}
                    >Forma szczegółowa</TableHeaderColumn>
                    <TableHeaderColumn dataField='idFi'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtons}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/firmy/components/FirmyTable.js